/* TORQUE — skrypt motywu (bez zależności) */
(function () {
  'use strict';

  var T = window.Torque || {};
  var routes = T.routes || { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' };
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var motion = T.animations !== false && !reduced;
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function on(el, ev, fn, opt) { if (el) el.addEventListener(ev, fn, opt); }

  /* ---------- pieniądze ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || T.moneyFormat || '{{amount_with_comma_separator}} zł';
    function fmt(n, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(n) || n == null) return '0';
      n = (n / 100).toFixed(precision);
      var parts = n.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var c = parts[1] ? decimal + parts[1] : '';
      return dollars + c;
    }
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount';
    var value;
    switch (key) {
      case 'amount': value = fmt(cents, 2); break;
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': value = fmt(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = fmt(cents, 0, ' '); break;
      default: value = fmt(cents, 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  /* ---------- komunikat ---------- */
  var toastTimer;
  function toast(msg, isError) {
    var el = $('[data-toast]');
    if (!el) return;
    el.textContent = msg;
    el.classList.toggle('is-error', !!isError);
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 3200);
  }

  /* ---------- pojawianie się przy przewijaniu + liczniki ---------- */
  function initReveal() {
    var targets = $$('[data-reveal], [data-compare], [data-count-to]');
    if (!('IntersectionObserver' in window) || !motion) {
      targets.forEach(function (el) { el.classList.add('is-in'); });
      $$('[data-count-to]').forEach(function (el) { el.textContent = Number(el.getAttribute('data-count-to')).toLocaleString('pl-PL'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        el.classList.add('is-in');
        if (el.hasAttribute('data-count-to')) countUp(el);
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    targets.forEach(function (el) { io.observe(el); });
  }
  function countUp(el) {
    var to = Number(el.getAttribute('data-count-to')) || 0;
    var dur = 1300, start = null;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(to * eased).toLocaleString('pl-PL');
      if (p < 1) requestAnimationFrame(step);
    }
    el.textContent = '0';
    requestAnimationFrame(step);
  }

  /* ---------- nagłówek ---------- */
  function initHeader() {
    var wrap = $('.shopify-section--header');
    var header = $('[data-header]');
    if (wrap && header && header.classList.contains('header--sticky')) {
      var last = window.scrollY;
      on(window, 'scroll', function () {
        var y = window.scrollY;
        var menuOpen = document.body.classList.contains('lock');
        if (!menuOpen) wrap.classList.toggle('is-hidden', y > last && y > 320);
        last = y;
      }, { passive: true });
    }

    var menu = $('[data-menu]');
    var burger = $('[data-menu-open]');
    if (menu && burger) {
      on(burger, 'click', function () { openDrawer(menu, burger); });
      $$('[data-menu-close]', menu).forEach(function (b) { on(b, 'click', function () { closeDrawer(menu, burger); }); });
    }
  }

  function openDrawer(drawer, trigger) {
    drawer.hidden = false;
    document.body.classList.add('lock');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    requestAnimationFrame(function () { requestAnimationFrame(function () { drawer.classList.add('is-open'); }); });
    var focusable = $('button, a, input', drawer);
    if (focusable) setTimeout(function () { focusable.focus({ preventScroll: true }); }, 50);
    drawer._trigger = trigger;
    drawer._esc = function (e) { if (e.key === 'Escape') closeDrawer(drawer); };
    document.addEventListener('keydown', drawer._esc);
  }
  function closeDrawer(drawer) {
    drawer.classList.remove('is-open');
    document.body.classList.remove('lock');
    if (drawer._trigger) { drawer._trigger.setAttribute('aria-expanded', 'false'); drawer._trigger.focus({ preventScroll: true }); }
    document.removeEventListener('keydown', drawer._esc);
    setTimeout(function () { if (!drawer.classList.contains('is-open')) drawer.hidden = true; }, 450);
  }

  /* ---------- rotatory (pasek ogłoszeń, krótkie opinie) ---------- */
  function initRotators() {
    $$('[data-rotator]').forEach(function (root) {
      var items = $$('[data-rotator-item]', root);
      if (items.length < 2) { if (items[0]) items[0].classList.add('is-active'); return; }
      var interval = Number(root.getAttribute('data-interval')) || 5000;
      var i = 0, timer;
      var dotsWrap = $('[data-rotator-dots]', root);
      var dots = [];
      if (dotsWrap) {
        items.forEach(function (_, n) {
          var b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('aria-label', String(n + 1));
          on(b, 'click', function () { go(n); restart(); });
          dotsWrap.appendChild(b);
          dots.push(b);
        });
      }
      function go(n) {
        var prev = items[i];
        prev.classList.remove('is-active');
        prev.classList.add('is-leaving');
        setTimeout(function () { prev.classList.remove('is-leaving'); }, 650);
        i = (n + items.length) % items.length;
        items[i].classList.add('is-active');
        dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      }
      function restart() { clearInterval(timer); if (motion) timer = setInterval(function () { go(i + 1); }, interval); }
      items.forEach(function (it, k) { it.classList.toggle('is-active', k === 0); });
      dots.forEach(function (d, k) { d.setAttribute('aria-current', k === 0 ? 'true' : 'false'); });
      on(root, 'mouseenter', function () { clearInterval(timer); });
      on(root, 'mouseleave', restart);
      restart();
      if (!motion && !dots.length) timer = setInterval(function () { go(i + 1); }, interval);
    });
  }

  /* ---------- odliczanie do prawdziwej daty ---------- */
  function initCountdown() {
    $$('[data-countdown]').forEach(function (el) {
      var raw = (el.getAttribute('data-end') || '').trim().replace(' ', 'T');
      var end = new Date(raw);
      if (isNaN(end.getTime())) return;
      var parts = {
        d: $('[data-cd-days]', el), h: $('[data-cd-hours]', el),
        m: $('[data-cd-minutes]', el), s: $('[data-cd-seconds]', el)
      };
      var daysWrap = $('[data-cd-days-wrap]', el);
      function pad(n) { return n < 10 ? '0' + n : String(n); }
      function set(node, val) {
        if (node.textContent !== val) {
          node.textContent = val;
          if (motion) { node.classList.remove('tick'); void node.offsetWidth; node.classList.add('tick'); }
        }
      }
      function tick() {
        var diff = end.getTime() - Date.now();
        if (diff <= 0) { el.hidden = true; clearInterval(timer); return; }
        el.hidden = false;
        var s = Math.floor(diff / 1000);
        var d = Math.floor(s / 86400); s -= d * 86400;
        var h = Math.floor(s / 3600); s -= h * 3600;
        var m = Math.floor(s / 60); s -= m * 60;
        daysWrap.hidden = d === 0;
        set(parts.d, String(d)); set(parts.h, pad(h)); set(parts.m, pad(m)); set(parts.s, pad(s));
      }
      var timer = setInterval(tick, 1000);
      tick();
    });
  }

  /* ---------- galeria + lightbox ---------- */
  function initGallery(section) {
    var gallery = $('[data-gallery]', section);
    if (!gallery) return;
    var track = $('[data-gallery-track]', gallery);
    var slides = $$('[data-slide]', gallery);
    var thumbs = $$('[data-thumb]', gallery);
    var current = $('[data-gallery-current]', gallery);
    var index = 0;

    function goTo(n, smooth) {
      n = Math.max(0, Math.min(slides.length - 1, n));
      track.scrollTo({ left: n * track.clientWidth, behavior: smooth === false ? 'auto' : 'smooth' });
    }
    function setActive(n) {
      if (n === index && thumbs[n] && thumbs[n].classList.contains('is-active')) return;
      index = n;
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === n); });
      if (thumbs[n]) {
        var wrap = thumbs[n].parentElement;
        var left = thumbs[n].offsetLeft - wrap.clientWidth / 2 + thumbs[n].clientWidth / 2;
        wrap.scrollTo({ left: left, behavior: 'smooth' });
      }
      if (current) current.textContent = String(n + 1);
      slides.forEach(function (s, k) {
        var v = $('video', s);
        if (v) { if (k === n) v.play().catch(function () {}); else v.pause(); }
      });
    }
    var raf;
    on(track, 'scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () { setActive(Math.round(track.scrollLeft / track.clientWidth)); });
    }, { passive: true });
    thumbs.forEach(function (t) { on(t, 'click', function () { goTo(Number(t.getAttribute('data-thumb'))); }); });
    on($('[data-gallery-prev]', gallery), 'click', function () { goTo(index - 1); });
    on($('[data-gallery-next]', gallery), 'click', function () { goTo(index + 1); });
    on(track, 'keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(index + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(index - 1); }
    });

    // przeciąganie myszą na desktopie
    if (canHover) {
      var down = false, startX = 0, startLeft = 0, moved = false;
      on(track, 'pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;
        down = true; moved = false; startX = e.clientX; startLeft = track.scrollLeft;
        track.style.scrollSnapType = 'none';
      });
      on(window, 'pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 4) moved = true;
        track.scrollLeft = startLeft - dx;
      });
      on(window, 'pointerup', function () {
        if (!down) return;
        down = false;
        track.style.scrollSnapType = '';
        goTo(Math.round(track.scrollLeft / track.clientWidth));
      });
      on(track, 'click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    }

    // lightbox
    var lb = $('[data-lightbox]', section);
    if (!lb || typeof lb.showModal !== 'function') return;
    var items = $$('[data-lightbox-item]', lb);
    var lbIndex = 0;
    function show(n) {
      if (!items.length) return;
      lbIndex = (n + items.length) % items.length;
      items.forEach(function (it, k) { it.classList.toggle('is-active', k === lbIndex); it.classList.remove('is-zoomed'); });
      var img = $('img', items[lbIndex]);
      if (img) img.loading = 'eager';
    }
    $$('[data-zoom]', gallery).forEach(function (btn) {
      on(btn, 'click', function () {
        var target = Number(btn.getAttribute('data-zoom'));
        var pos = items.findIndex(function (it) { return Number(it.getAttribute('data-lightbox-item')) === target; });
        show(pos < 0 ? 0 : pos);
        lb.showModal();
        document.body.classList.add('lock');
      });
    });
    on(lb, 'close', function () { document.body.classList.remove('lock'); });
    on($('[data-lightbox-prev]', lb), 'click', function () { show(lbIndex - 1); });
    on($('[data-lightbox-next]', lb), 'click', function () { show(lbIndex + 1); });
    on(lb, 'keydown', function (e) {
      if (e.key === 'ArrowRight') show(lbIndex + 1);
      if (e.key === 'ArrowLeft') show(lbIndex - 1);
    });
    items.forEach(function (it) {
      var img = $('img', it);
      if (!img) return;
      on(img, 'click', function (e) {
        var r = img.getBoundingClientRect();
        img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
        it.classList.toggle('is-zoomed');
      });
      on(img, 'mousemove', function (e) {
        if (!it.classList.contains('is-zoomed')) return;
        var r = img.getBoundingClientRect();
        img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
      });
    });
    var tx = null;
    on(lb, 'touchstart', function (e) { tx = e.touches[0].clientX; }, { passive: true });
    on(lb, 'touchend', function (e) {
      if (tx == null) return;
      var dx = e.changedTouches[0].clientX - tx;
      if (Math.abs(dx) > 50) show(lbIndex + (dx < 0 ? 1 : -1));
      tx = null;
    });
  }

  /* ---------- okna dialogowe (tabela rozmiarów) ---------- */
  function initModals() {
    on(document, 'click', function (e) {
      var opener = e.target.closest('[data-open-size-chart]');
      if (opener) {
        e.preventDefault();
        e.stopPropagation();
        var scope = opener.closest('[data-pdp]') || document;
        var dlg = $('[data-size-chart]', scope);
        if (dlg && typeof dlg.showModal === 'function') dlg.showModal();
        return;
      }
      var closer = e.target.closest('[data-modal-close]');
      if (closer) { var d = closer.closest('dialog'); if (d) d.close(); }
    });
    $$('dialog').forEach(function (d) {
      on(d, 'click', function (e) {
        if (e.target === d && !d.classList.contains('lightbox')) d.close();
        if (d.classList.contains('lightbox') && (e.target === d || e.target.classList.contains('lightbox__stage') || e.target.classList.contains('lightbox__item'))) d.close();
      });
    });
  }

  /* ---------- akordeony z płynnym otwieraniem ---------- */
  function initAccordions() {
    if (!motion) return;
    $$('details.accordion').forEach(function (d) {
      var summary = $('summary', d);
      var content = $('.accordion__content', d);
      if (!summary || !content) return;
      on(summary, 'click', function (e) {
        e.preventDefault();
        if (d._anim) d._anim.cancel();
        if (d.open) {
          var h = content.offsetHeight;
          d._anim = content.animate([{ height: h + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 280, easing: 'cubic-bezier(.2,.7,.2,1)' });
          d._anim.onfinish = function () { d.open = false; d._anim = null; };
        } else {
          d.open = true;
          var target = content.offsetHeight;
          d._anim = content.animate([{ height: '0px', opacity: 0 }, { height: target + 'px', opacity: 1 }], { duration: 340, easing: 'cubic-bezier(.2,.7,.2,1)' });
          d._anim.onfinish = function () { d._anim = null; };
        }
      });
    });
  }

  /* =========================================================
     KOSZYK
     ========================================================= */
  var Cart = {
    drawer: null,
    pending: false,

    init: function () {
      this.drawer = $('[data-cart-drawer]');
      var self = this;
      on(document, 'click', function (e) {
        var opener = e.target.closest('[data-cart-open]');
        if (opener && self.drawer) { e.preventDefault(); self.open(opener); return; }
        if (e.target.closest('[data-cart-close]') && self.drawer) { e.preventDefault(); closeDrawer(self.drawer); return; }

        var change = e.target.closest('[data-line-change]');
        if (change) { e.preventDefault(); self.change(change.getAttribute('data-key'), Number(change.getAttribute('data-qty')), change); return; }
        var remove = e.target.closest('[data-line-remove]');
        if (remove) { e.preventDefault(); self.change(remove.getAttribute('data-key'), 0, remove); return; }
        var quick = e.target.closest('[data-quick-add]');
        if (quick) { e.preventDefault(); self.add([{ id: Number(quick.getAttribute('data-quick-add')), quantity: 1 }], quick); }
      });
    },

    open: function (trigger) {
      if (!this.drawer) { window.location.href = routes.cart; return; }
      openDrawer(this.drawer, trigger || null);
    },

    sectionsParam: function () {
      return this.drawer ? ['cart-drawer'] : [];
    },

    fetchCart: function () {
      return fetch(routes.root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
    },

    add: function (items, sourceBtn) {
      var self = this;
      var body = { items: items };
      if (this.drawer) { body.sections = this.sectionsParam(); body.sections_url = window.location.pathname; }
      if (sourceBtn) sourceBtn.classList.add('is-loading');
      return fetch(routes.cartAdd + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
        .then(function (res) {
          if (sourceBtn) sourceBtn.classList.remove('is-loading');
          if (!res.ok) {
            var msg = (res.data && (res.data.description || res.data.message)) || T.strings.error;
            toast(msg, true);
            throw new Error(msg);
          }
          if (T.cartType === 'page' || !self.drawer) { window.location.href = routes.cart; return res.data; }
          if (res.data.sections) self.renderSections(res.data.sections);
          return self.afterChange().then(function () {
            self.open();
            return res.data;
          });
        })
        .catch(function (err) {
          if (sourceBtn) sourceBtn.classList.remove('is-loading');
          throw err;
        });
    },

    change: function (key, qty, sourceEl) {
      var self = this;
      if (self.pending) return Promise.resolve();
      self.pending = true;
      var line = sourceEl && sourceEl.closest('[data-cart-item]');
      if (line) line.classList.add('is-updating');
      var body = { id: key, quantity: Math.max(0, qty) };
      if (this.drawer) { body.sections = this.sectionsParam(); body.sections_url = window.location.pathname; }
      return fetch(routes.cartChange + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
        .then(function (res) {
          self.pending = false;
          if (!res.ok) { toast((res.data && res.data.description) || T.strings.error, true); if (line) line.classList.remove('is-updating'); return; }
          if ($('[data-cart-page]')) { return self.syncGifts(res.data).then(function () { window.location.reload(); }); }
          if (res.data.sections) self.renderSections(res.data.sections);
          return self.afterChange(res.data);
        })
        .catch(function () { self.pending = false; if (line) line.classList.remove('is-updating'); toast(T.strings.error, true); });
    },

    renderSections: function (sections) {
      var html = sections && sections['cart-drawer'];
      if (!html || !this.drawer) return;
      var wasDone = this.isShippingDone();
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = $('[data-cart-drawer-content]', doc);
      var currentContent = $('[data-cart-drawer-content]', this.drawer);
      if (fresh && currentContent) currentContent.innerHTML = fresh.innerHTML;
      var nowDone = this.isShippingDone();
      if (!wasDone && nowDone) confetti();
    },

    isShippingDone: function () {
      var m = this.drawer && $('[data-ship-meter]', this.drawer);
      return !!(m && m.getAttribute('data-done') === 'true');
    },

    afterChange: function (cartData) {
      var self = this;
      var p = cartData && cartData.items ? Promise.resolve(cartData) : this.fetchCart();
      return p.then(function (cart) {
        return self.syncGifts(cart).then(function (changed) {
          if (changed) return self.refreshDrawer().then(self.fetchCart.bind(self));
          return cart;
        });
      }).then(function (cart) {
        self.updateCount(cart.item_count);
        return cart;
      });
    },

    refreshDrawer: function () {
      var self = this;
      if (!this.drawer) return Promise.resolve();
      return fetch(window.location.pathname + '?sections=cart-drawer')
        .then(function (r) { return r.json(); })
        .then(function (sections) { self.renderSections(sections); });
    },

    // gratisy usuwane, gdy klient zmniejszy liczbę sztuk poniżej progu zestawu
    syncGifts: function (cart) {
      if (!cart || !cart.items) return Promise.resolve(false);
      var removals = [];
      cart.items.forEach(function (item) {
        var props = item.properties || {};
        if (!props._gift) return;
        var forId = Number(props._gift_for);
        var min = Number(props._gift_min) || 1;
        var mainQty = cart.items.reduce(function (sum, it) {
          var p = it.properties || {};
          return !p._gift && it.product_id === forId ? sum + it.quantity : sum;
        }, 0);
        if (mainQty < min) removals.push(item.key);
      });
      if (!removals.length) return Promise.resolve(false);
      var updates = {};
      removals.forEach(function (k) { updates[k] = 0; });
      return fetch(routes.root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates })
      }).then(function () { return true; }).catch(function () { return false; });
    },

    updateCount: function (count) {
      $$('[data-cart-count]').forEach(function (el) {
        el.textContent = count;
        el.classList.toggle('is-empty', !count);
        el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump');
      });
    }
  };

  function confetti() {
    if (!motion) return;
    var wrap = document.createElement('div');
    wrap.className = 'confetti';
    var colors = [getComputedStyle(document.documentElement).getPropertyValue('--c-accent').trim() || '#FF6A13', '#FFB547', '#178A55', '#16181D'];
    var originX = window.innerWidth - Math.min(440, window.innerWidth) / 2;
    for (var i = 0; i < 36; i++) {
      var p = document.createElement('i');
      p.style.left = originX + 'px';
      p.style.top = '120px';
      p.style.background = colors[i % colors.length];
      p.style.setProperty('--x', (Math.random() * 360 - 180) + 'px');
      p.style.setProperty('--y', (Math.random() * 320 + 60) + 'px');
      p.style.setProperty('--r', (Math.random() * 720 - 360) + 'deg');
      p.style.animationDelay = (Math.random() * 120) + 'ms';
      wrap.appendChild(p);
    }
    document.body.appendChild(wrap);
    setTimeout(function () { wrap.remove(); }, 1800);
  }

  /* =========================================================
     ZESTAWY (1/2/3 szt. + gratisy)
     ========================================================= */
  function initBundle(section) {
    var root = $('[data-bundle]', section);
    if (!root) return null;
    var product;
    try { product = JSON.parse($('[data-bundle-product]', root).textContent); } catch (e) { return null; }
    var tiers = $$('[data-tier]', root);
    var form = $('form', root);
    var atc = $('[data-bundle-atc]', root);
    var atcPrice = $('[data-atc-price]', root);
    var atcLabel = $('[data-atc-label]', root);
    var defaultLabel = atcLabel ? atcLabel.textContent : T.strings.addToCart;
    var sticky = $('[data-sticky-price]', section);
    var productId = Number(root.getAttribute('data-product-id'));

    function selected() { return tiers.filter(function (t) { return t.classList.contains('is-selected'); })[0] || tiers[0]; }

    function findVariant(values) {
      return product.variants.filter(function (v) {
        return v.options.every(function (o, i) { return values[i] === undefined || o === values[i]; });
      })[0];
    }

    function unitsOf(tier) {
      var rows = $$('[data-unit]', tier);
      var qty = Number(tier.getAttribute('data-qty')) || 1;
      var first = product.variants.filter(function (v) { return v.available; })[0] || product.variants[0];
      if (!rows.length) {
        var arr = [];
        for (var i = 0; i < qty; i++) arr.push({ variant: first, row: null });
        return arr;
      }
      return rows.map(function (row) {
        var values = $$('select', row).map(function (s) { return s.value; });
        return { variant: findVariant(values), row: row };
      });
    }

    function refresh() {
      var tier = selected();
      if (!tier) return;
      var disc = Number(tier.getAttribute('data-discount')) || 0;
      var units = unitsOf(tier);
      var ok = true, sum = 0, compare = 0;
      units.forEach(function (u) {
        var valid = u.variant && u.variant.available;
        if (u.row) $$('select', u.row).forEach(function (s) { s.classList.toggle('is-unavailable', !valid); });
        if (!valid) { ok = false; return; }
        sum += u.variant.price;
        compare += Math.max(u.variant.compare_at_price || 0, u.variant.price);
      });
      var total = Math.round(sum * (100 - disc) / 100);
      if (ok) {
        var pEl = $('[data-tier-price]', tier);
        if (pEl) pEl.textContent = formatMoney(total);
        var cEl = $('[data-tier-compare]', tier);
        if (cEl) cEl.textContent = formatMoney(compare);
        if (atcPrice) atcPrice.textContent = formatMoney(total);
        if (sticky) sticky.textContent = formatMoney(total);
      } else if (atcPrice) {
        atcPrice.textContent = '';
      }
      if (atc && product.available) {
        atc.disabled = !ok;
        if (atcLabel) atcLabel.textContent = ok ? defaultLabel : (T.strings.soldOut || 'Niedostępne');
      }
    }

    function select(tier, focus) {
      tiers.forEach(function (t) {
        var is = t === tier;
        t.classList.toggle('is-selected', is);
        t.setAttribute('aria-checked', is ? 'true' : 'false');
        t.setAttribute('tabindex', is ? '0' : '-1');
      });
      if (focus) tier.focus({ preventScroll: true });
      refresh();
    }

    tiers.forEach(function (tier, idx) {
      on(tier, 'click', function (e) {
        if (e.target.closest('select, button, a')) { if (!tier.classList.contains('is-selected')) select(tier); return; }
        if (!tier.classList.contains('is-selected')) {
          select(tier);
          if (motion) { tier.classList.add('is-pressed'); setTimeout(function () { tier.classList.remove('is-pressed'); }, 160); }
        }
      });
      on(tier, 'keydown', function (e) {
        if (e.target !== tier) return;
        var n = null;
        if (e.key === 'ArrowDown' || e.key === 'ArrowRight') n = idx + 1;
        if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') n = idx - 1;
        if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); select(tier); return; }
        if (n !== null) { e.preventDefault(); select(tiers[(n + tiers.length) % tiers.length], true); }
      });
      $$('select', tier).forEach(function (s) { on(s, 'change', refresh); });
    });

    if (!selected().classList.contains('is-selected')) select(tiers[0]);
    refresh();

    function submit(e) {
      if (e) e.preventDefault();
      var tier = selected();
      if (!tier || !atc || atc.disabled) return;
      var units = unitsOf(tier);
      if (units.some(function (u) { return !u.variant || !u.variant.available; })) return;
      var qty = units.length;
      var merged = {};
      var order = [];
      units.forEach(function (u) {
        if (!merged[u.variant.id]) { merged[u.variant.id] = 0; order.push(u.variant.id); }
        merged[u.variant.id] += 1;
      });
      var items = order.map(function (id) { return { id: id, quantity: merged[id] }; });
      var giftIds = (tier.getAttribute('data-gifts') || '').split(',').filter(Boolean).map(Number);

      var giftsPromise = giftIds.length ? Cart.fetchCart().then(function (cart) {
        var inCart = {};
        (cart.items || []).forEach(function (it) { if (it.properties && it.properties._gift) inCart[it.variant_id] = true; });
        return giftIds.filter(function (id) { return !inCart[id]; });
      }).catch(function () { return giftIds; }) : Promise.resolve([]);

      atc.classList.add('is-loading');
      giftsPromise.then(function (gifts) {
        gifts.forEach(function (id) {
          items.push({ id: id, quantity: 1, properties: { _gift: 'true', _gift_for: String(productId), _gift_min: String(qty) } });
        });
        return Cart.add(items, atc);
      }).then(function () {
        atc.classList.add('is-added');
        if (atcLabel) atcLabel.textContent = T.strings.added || 'Dodano';
        setTimeout(function () { atc.classList.remove('is-added'); if (atcLabel) atcLabel.textContent = defaultLabel; }, 1800);
      }).catch(function () {
        atc.classList.remove('is-loading');
      });
    }
    on(form, 'submit', submit);
    return { submit: submit, atc: atc };
  }

  /* ---------- przyklejony pasek zakupu ---------- */
  function initSticky(section, bundle) {
    var bar = $('[data-sticky-atc]', section);
    if (!bar || !bundle || !bundle.atc || !('IntersectionObserver' in window)) return;
    var btn = $('[data-sticky-btn]', bar);
    var footer = $('.footer');
    var atcVisible = true, footerVisible = false, passed = false;
    function update() {
      var show = !atcVisible && passed && !footerVisible;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      btn.tabIndex = show ? 0 : -1;
    }
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        atcVisible = e.isIntersecting;
        passed = e.boundingClientRect.top < 0;
        update();
      });
    }).observe(bundle.atc);
    if (footer) new IntersectionObserver(function (entries) { footerVisible = entries[0].isIntersecting; update(); }).observe(footer);
    on(btn, 'click', function () { bundle.submit(); });
  }

  /* ---------- szacowana dostawa ---------- */
  function initDelivery(section) {
    $$('[data-delivery]', section).forEach(function (el) {
      var min = Number(el.getAttribute('data-min')) || 5;
      var max = Number(el.getAttribute('data-max')) || 10;
      var tpl = el.getAttribute('data-template') || '';
      function addBusinessDays(n) {
        var d = new Date();
        while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; }
        return d;
      }
      var f = new Intl.DateTimeFormat('pl-PL', { weekday: 'short', day: 'numeric', month: 'short' });
      var esc = function (s) { var div = document.createElement('div'); div.textContent = s; return div.innerHTML; };
      var html = esc(tpl)
        .replace('[od]', '<strong>' + esc(f.format(addBusinessDays(min))) + '</strong>')
        .replace('[do]', '<strong>' + esc(f.format(addBusinessDays(max))) + '</strong>');
      var target = $('[data-delivery-text]', el);
      if (target && tpl) target.innerHTML = html;
    });
  }

  /* =========================================================
     POKRĘTŁO
     ========================================================= */
  function initDial(root) {
    var dial = $('[data-dial]', root);
    if (!dial) return;
    var card = $('[data-dial-card]', root);
    var knob = $('[data-dial-knob]', root);
    var progress = $('[data-dial-progress]', root);
    var readout = $('[data-dial-readout]', root);
    var levels = $$('[data-dial-level]', root);
    var segs = $$('[data-meter-seg]', root);
    var steps = Math.max(2, Number(dial.getAttribute('data-steps')) || levels.length || 3);
    var MIN = -135, MAX = 135;
    var level = 1, touched = false;

    function angleFor(l) { return MIN + (l - 1) / (steps - 1) * (MAX - MIN); }
    function paint(angle) {
      var frac = (angle - MIN) / (MAX - MIN);
      dial.style.setProperty('--angle', angle + 'deg');
      if (progress) progress.style.strokeDasharray = (270 * frac).toFixed(1) + ' 360';
      if (card) card.style.setProperty('--lvl', frac.toFixed(3));
    }
    function setLevel(l, opts) {
      opts = opts || {};
      l = Math.max(1, Math.min(steps, l));
      var changed = l !== level;
      level = l;
      if (!opts.keepAngle) paint(angleFor(l));
      segs.forEach(function (s) { s.classList.toggle('is-on', Number(s.getAttribute('data-meter-seg')) <= l); });
      levels.forEach(function (li) { li.classList.toggle('is-active', Number(li.getAttribute('data-dial-level')) === l); });
      var lvlEl = levels[l - 1];
      var title = lvlEl ? $('.dial-level__title', lvlEl).textContent : String(l);
      dial.setAttribute('aria-valuenow', String(l));
      dial.setAttribute('aria-valuetext', title);
      if (readout && (changed || opts.force)) {
        readout.textContent = title;
        if (motion) { readout.classList.remove('swap'); void readout.offsetWidth; readout.classList.add('swap'); }
      }
      if (changed && opts.haptic && navigator.vibrate) { try { navigator.vibrate(8); } catch (e) {} }
    }

    // przeciąganie
    var dragging = false;
    function angleFromEvent(e) {
      var r = dial.getBoundingClientRect();
      var cx = r.left + r.width / 2, cy = r.top + r.height / 2;
      var deg = Math.atan2(e.clientX - cx, cy - e.clientY) * 180 / Math.PI; // 0 = góra, zgodnie z zegarem
      if (deg > MAX) deg = deg > 157.5 ? MIN : MAX; // martwa strefa na dole
      if (deg < MIN) deg = deg < -157.5 ? MAX : MIN;
      return Math.max(MIN, Math.min(MAX, deg));
    }
    on(dial, 'pointerdown', function (e) {
      touched = true; dragging = true;
      dial.setPointerCapture(e.pointerId);
      dial.classList.add('is-dragging');
      e.preventDefault();
    });
    on(dial, 'pointermove', function (e) {
      if (!dragging) return;
      var a = angleFromEvent(e);
      paint(a);
      var l = Math.round((a - MIN) / (MAX - MIN) * (steps - 1)) + 1;
      setLevel(l, { keepAngle: true, haptic: true });
    });
    function end() {
      if (!dragging) return;
      dragging = false;
      dial.classList.remove('is-dragging');
      paint(angleFor(level));
    }
    on(dial, 'pointerup', end);
    on(dial, 'pointercancel', end);
    on(dial, 'keydown', function (e) {
      var map = { ArrowRight: 1, ArrowUp: 1, ArrowLeft: -1, ArrowDown: -1 };
      if (map[e.key]) { e.preventDefault(); touched = true; setLevel(level + map[e.key]); }
      if (e.key === 'Home') { e.preventDefault(); touched = true; setLevel(1); }
      if (e.key === 'End') { e.preventDefault(); touched = true; setLevel(steps); }
    });
    $$('[data-dial-step]', root).forEach(function (b) {
      on(b, 'click', function () { touched = true; setLevel(level + Number(b.getAttribute('data-dial-step'))); });
    });
    $$('[data-dial-set]', root).forEach(function (b) {
      on(b, 'click', function () { touched = true; setLevel(Number(b.getAttribute('data-dial-set'))); });
    });

    setLevel(1, { force: true });

    // jednorazowa demonstracja po wejściu w widok
    if (motion && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        io.disconnect();
        var seq = [];
        for (var i = 2; i <= steps; i++) seq.push(i);
        seq.push(Math.ceil(steps / 2));
        var k = 0;
        (function next() {
          if (touched || k >= seq.length) return;
          setLevel(seq[k++]);
          setTimeout(next, 750);
        })();
      }, { threshold: 0.55 });
      setTimeout(function () { io.observe(card || dial); }, 300);
    }
  }

  /* ---------- zakładki „Jak to działa” ---------- */
  function initShowcase(root) {
    var tabs = $$('[data-showcase-tab]', root);
    var frames = $$('[data-showcase-frame]', root);
    if (!tabs.length) return;
    var interval = Number(root.getAttribute('data-interval')) || 6000;
    root.style.setProperty('--showcase-interval', interval + 'ms');
    var current = 0, visible = false;
    function activate(n) {
      current = (n + tabs.length) % tabs.length;
      tabs.forEach(function (t, k) {
        var is = k === current;
        t.classList.toggle('is-active', is);
        t.classList.remove('is-running');
        t.setAttribute('aria-selected', is ? 'true' : 'false');
      });
      frames.forEach(function (f, k) { f.classList.toggle('is-active', k === current); });
      run();
    }
    function run() {
      if (!motion || !visible || tabs.length < 2) return;
      var t = tabs[current];
      void t.offsetWidth;
      t.classList.add('is-running');
    }
    tabs.forEach(function (t, k) {
      on(t, 'click', function () { activate(k); });
      var bar = $('.feature__progress span', t);
      on(bar, 'animationend', function () { if (t.classList.contains('is-active')) activate(current + 1); });
    });
    if (canHover) {
      on(root, 'mouseenter', function () { root.classList.add('is-paused'); });
      on(root, 'mouseleave', function () { root.classList.remove('is-paused'); });
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        root.classList.toggle('is-paused', !visible);
        if (visible && !$('.feature.is-running', root)) run();
      }, { threshold: 0.35 }).observe(root);
    }
  }

  /* ---------- paralaksa, pochylenie kart, przewijanie myszą ---------- */
  function initParallax() {
    if (!motion) return;
    var els = $$('[data-parallax-inner]');
    if (!els.length) return;
    var ticking = false;
    function update() {
      var vh = window.innerHeight;
      els.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < -100 || r.top > vh + 100) return;
        var py = (r.top + r.height / 2 - vh / 2) * -0.08;
        el.style.setProperty('--py', py.toFixed(1));
      });
      ticking = false;
    }
    on(window, 'scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }
  function initTilt() {
    if (!motion || !canHover) return;
    $$('[data-tilt]').forEach(function (el) {
      on(el, 'pointermove', function (e) {
        var r = el.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - .5;
        var y = (e.clientY - r.top) / r.height - .5;
        el.style.transform = 'perspective(900px) rotateY(' + (x * 7).toFixed(2) + 'deg) rotateX(' + (-y * 7).toFixed(2) + 'deg) translateY(-4px)';
      });
      on(el, 'pointerleave', function () { el.style.transform = ''; });
    });
  }
  function initDragScroll() {
    if (!canHover) return;
    $$('[data-drag-scroll]').forEach(function (sc) {
      var down = false, x0 = 0, l0 = 0, moved = false;
      on(sc, 'pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.target.closest('button, a, video')) return;
        down = true; moved = false; x0 = e.clientX; l0 = sc.scrollLeft;
      });
      on(window, 'pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - x0;
        if (Math.abs(dx) > 5) { moved = true; sc.classList.add('is-dragging'); }
        sc.scrollLeft = l0 - dx;
      });
      on(window, 'pointerup', function () { if (down) { down = false; sc.classList.remove('is-dragging'); } });
      on(sc, 'click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    });
  }

  /* ---------- filmy pionowe ---------- */
  function initUgc() {
    var vids = $$('.ugc__video');
    if (!vids.length) return;
    if ('IntersectionObserver' in window && motion) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var v = e.target;
          if (v.tagName !== 'VIDEO') return;
          if (e.isIntersecting) { v.preload = 'auto'; v.play().catch(function () {}); } else v.pause();
        });
      }, { threshold: 0.5 });
      vids.forEach(function (v) { io.observe(v); });
    }
    $$('[data-ugc-sound]').forEach(function (btn) {
      on(btn, 'click', function () {
        var v = $('video', btn.parentElement);
        if (!v) return;
        var unmute = v.muted;
        $$('.ugc__video').forEach(function (o) { if (o.tagName === 'VIDEO') o.muted = true; });
        $$('[data-ugc-sound]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
        v.muted = !unmute;
        if (unmute) { v.play().catch(function () {}); btn.setAttribute('aria-pressed', 'true'); }
      });
    });
  }

  /* ---------- drobne ---------- */
  function initMisc() {
    $$('select[data-autosubmit]').forEach(function (s) { on(s, 'change', function () { s.form.submit(); }); });
  }

  /* ---------- start ---------- */
  function boot() {
    initReveal();
    initHeader();
    initRotators();
    initCountdown();
    initModals();
    initAccordions();
    Cart.init();
    $$('[data-pdp]').forEach(function (section) {
      initGallery(section);
      var bundle = initBundle(section);
      initSticky(section, bundle);
      initDelivery(section);
    });
    $$('[data-dial-demo]').forEach(initDial);
    $$('[data-showcase]').forEach(initShowcase);
    initParallax();
    initTilt();
    initDragScroll();
    initUgc();
    initMisc();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // ponowna inicjalizacja w edytorze motywu
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target;
    $$('[data-reveal], [data-compare]', s).forEach(function (el) { el.classList.add('is-in'); });
    $$('[data-pdp]', s).forEach(function (section) {
      initGallery(section);
      var b = initBundle(section);
      initSticky(section, b);
      initDelivery(section);
    });
    $$('[data-dial-demo]', s).forEach(initDial);
    $$('[data-showcase]', s).forEach(initShowcase);
    $$('[data-count-to]', s).forEach(function (el) { el.textContent = el.getAttribute('data-count-to'); });
    if ($('[data-cart-drawer]', s)) Cart.drawer = $('[data-cart-drawer]');
  });

  window.Torque = Object.assign(T, { formatMoney: formatMoney, cart: Cart });
})();
